// extracted by mini-css-extract-plugin
module.exports = {"tableBody":"TableBody_tableBody__17H1E"};